// Define an array of currency objects with code and symbol properties
export const currencyList = [
  {
    code: "GBP",
    symbol: "£",
  },
  {
    code: "EUR",
    symbol: "€",
  },
  {
    code: "USD",
    symbol: "$",
  },
];

// Use the array of currency objects to create a new Map object with currency code as key and symbol as value
export const currencyMap = new Map(currencyList.map((c) => [c.code, c.symbol]));

// Define a function that takes a currency code and an array of currency objects, and returns the currency object that matches the code
export function findCurrencyByCode(code, currencies) {
  return currencies.find((currency) => currency.code === code);
}

// Define a function that takes an amount and a currency code, formats the amount to 2 decimal places, and returns the amount with the currency symbol or code
export function formatCurrencyAmount(amount, currencyCode) {
  // Round the amount to 2 decimal places
  const roundedAmount = Math.round(amount * 100) / 100;
  // Convert the rounded amount to a string with 2 decimal places
  const fixedAmount = roundedAmount.toFixed(2);

  // Get the symbol for the given currency code from the currencyMap
  const symbol = currencyMap.get(currencyCode);

  // If a symbol is found for the currency code, append the symbol to the formatted amount and return it
  if (symbol) {
    return `${symbol}${fixedAmount}`;
  }
  // Otherwise, append the currency code to the formatted amount and return it
  else {
    return `${fixedAmount} ${currencyCode}`;
  }
}
